import React from "react";
import ReactDOM from "react-dom";
import "./index.css";
import * as serviceWorker from "./serviceWorker";
import { BrowserRouter } from "react-router-dom";
import Router from "./Components/Router";
import { MuiThemeProvider, createMuiTheme } from "@material-ui/core/styles";
import { UserProvider } from "./Contexts/user";

// Or Create your Own theme:
const theme = createMuiTheme({
  palette: {
    primary: {
      main: "#e84e24",
    },
  },
});

ReactDOM.render(
  <React.StrictMode>
    <BrowserRouter>
      <MuiThemeProvider theme={theme}>
        <UserProvider>
          <Router />
        </UserProvider>
      </MuiThemeProvider>
    </BrowserRouter>
  </React.StrictMode>,
  document.getElementById("root")
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
